import { ChevronDown } from 'lucide-react';
import { useState } from 'react';

import type { JiraTransition } from '@/types';

import { TransitionList } from './TransitionList';

export interface TransitionFlowAccordionProps {
  title: string;
  description: string;
  transitions: JiraTransition[];
  selectedTransitionIds: string[];
  availableTransitions: JiraTransition[];
  onChange: (transitionIds: string[]) => void;
  disabled?: boolean;
}

export const TransitionFlowAccordion = ({
  title,
  description,
  transitions,
  selectedTransitionIds,
  availableTransitions,
  onChange,
  disabled = false,
}: TransitionFlowAccordionProps) => {
  const [isOpen, setIsOpen] = useState(true);

  return (
    <div className="border-chariot-stroke bg-chariot-background-secondary rounded-lg border">
      <button
        type="button"
        onClick={() => setIsOpen(!isOpen)}
        className="hover:bg-chariot-background-tertiary bg-chariot-background-secondary items-center justify-between rounded-lg px-4 py-3 text-left transition-colors"
      >
        <div className="flex flex-col gap-1">
          <span className="text-chariot-text-primary font-medium">{title}</span>
          <span className="text-chariot-text-secondary text-sm">
            {description}
          </span>
        </div>
        <ChevronDown
          className={`text-chariot-text-secondary h-5 w-5 transition-transform duration-200 ${
            isOpen ? 'rotate-180' : ''
          }`}
        />
      </button>

      <div
        className="grid rounded-lg transition-[grid-template-rows] duration-200 ease-in-out"
        style={{
          gridTemplateRows: isOpen ? '1fr' : '0fr',
        }}
      >
        <div className="overflow-hidden rounded-lg">
          <div className="border-chariot-stroke bg-chariot-background-primary border-t p-4">
            <TransitionList
              transitions={transitions}
              selectedTransitionIds={selectedTransitionIds}
              availableTransitions={availableTransitions}
              onChange={onChange}
              disabled={disabled}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
